import { createClient, type InsForgeClient } from "@insforge/sdk";
import { readBackendConfig } from "@/lib/backend-config";

let _client: InsForgeClient | null = null;
const TRAILING_SLASHES_RE = /\/+$/;

function getFunctionsUrl(baseUrl: string): string {
  return `${baseUrl.replace(TRAILING_SLASHES_RE, "")}/functions`;
}

/** Lazily initializes the browser InsForge client from runtime backend config. */
export const insforge: InsForgeClient = new Proxy({} as InsForgeClient, {
  get(_target, prop) {
    if (!_client) {
      const { url, anonKey } = readBackendConfig();
      _client = createClient({
        baseUrl: url,
        anonKey,
        functionsUrl: getFunctionsUrl(url),
      });
    }
    const value = Reflect.get(_client, prop);
    return typeof value === "function" ? value.bind(_client) : value;
  },
});
